require('./style.less');

var Marionette = require('marionette'),
    Raphael = require('raphael'),
    _ = require('underscore'),
    CanvasState = require('./canvas.state'),
    CanvasView = require('./views/imgCanvas'),
    Shapes = require('./models/shapes'),
    fvChannel = require('glRadio').channel('FV');


var ShapeUtils = require('./models/shapeUtils');

require('extendRaphael');



/*
* Store Raphael customAttributes on the Raphael.fn namespace.
* This can then be referenced to apply to any Paper instances created that need them.
* this may fit better on FV or setup in FV-bootstrap (or put on extendRaphael) -- here now for clarity.
* Actually after first set, can reference from Raphael._Paper.prototype.customAttributes I believe but this works.
* Note: need CA's applied directly to the paper to write them on the shapes.
* */
if (!Raphael.fn.customAttributes) {

    Raphael.fn.customAttributes = {};

    Raphael.fn.customAttributes['shape-type'] = function(type) {
        return type;
    };
}


var instVars = {
    vChannel: null,
    pageCanvasCh: null,

    /*
    * A collection shape models.
    * Correspond to shape property of pgNoteModel (can have multi from diff pages).
    * Contains reference to the pageNoteModel.
    * Set from page.shapeModelsToRender + newly added shapes after they are drawn.
    * New ones added when new shape drawn but isn't unsaved
    * */
    shapes: null,

    state: null,
    canvasView: null,
    page: null,
    scale: null

};



module.exports = Marionette.Object.extend({

    initialize: function(options) {

        _.extend( this, instVars, _.pick( options, 'scale', 'page', 'vChannel', 'pageCanvasCh' ), {
            shapes: new Shapes(),
            state: new CanvasState() // DVBC-1747 -- need to reset each time ... don't want a reference
        });


        // outer comm w/page and inner comm just in canvas through here
        this.pageCanvasCh.reply(    _.extend(this.outerRequests, this.localRequests), this);
        this.pageCanvasCh.comply(   _.extend(this.outerCommands, this.localCommands), this);

        Marionette.bindEntityEvents( this, this.pageCanvasCh, this.localEvents );


        // Create as much of the canvas view prior to calling render which requires it to be in the DOM
        // ( Doesn't render shapes or set bounds )
        this.canvasView = new CanvasView({
            channel: this.pageCanvasCh
        });

    },


    /**
     * Sets the shape model collection back from reading in from note model attributes,
     * and now find and redact search models.
     * userProvidedShapes: if provided, use them, and none from the canvas
     * newShapeModelsOfActiveNote: added if not userProvidedShapes -- see notes in re-render
     */
    _setShapesCollection: function( userProvidedShapes, newShapeModelsOfActiveNote  ) {

        var shapes = [];

        if ( !userProvidedShapes ) {

            // 1) normal -- get the shapes from the page
            shapes = this.page.shapeModelsToRender();

            // Special case -- add shape model for full page redactions to shapes collection
            // ( the activeNote, if new, is not yet a part of the collection )
            // ( No drawing done for this shape )
            var activeNote = this.pageCanvasCh.request('activeNote');
            if ( activeNote && activeNote.isFullPageRedactionNote() && activeNote.isNew() ) {
                shapes.push(  activeNote.getShape() );
            }

            // See notes from canvas.re-render for the active note
            if ( newShapeModelsOfActiveNote ) {
                shapes = shapes.concat( newShapeModelsOfActiveNote );
            }

            // 2) Add 'Find and Redact' shapes for the page if they exist

            var findAndRedactSearchModel =
                this.vChannel.request('findAndRedactSearchModel');

            if ( findAndRedactSearchModel && findAndRedactSearchModel.searchHasResults() ) {

                var pageHitShapes = findAndRedactSearchModel.get('searchResults').getAllShapesPerPage(  this.page.get('pageId') );

                if ( pageHitShapes && pageHitShapes.length > 0 ) {

                    shapes = shapes.concat( pageHitShapes ); // note: will be rendered from model

                }

            }

        } else {

            shapes = userProvidedShapes;

        }


        this.shapes.set( shapes );

    },
    localEvents: {
        'shapeView:toggleMouseOver':    'toggleShapeMouseOver' /* forwarding the mouseover/mouseevent of shapes of shapes on the canvas */
    },
    outerRequests: {

        getShapeAttrsToPersist: function( note, scale ) {

            return this.shapes.getShapeAttributesOfNote( note, scale, this.page );

        }

    },
    outerCommands: {

        //TODO: cache AND/or fwd for perf ..
        updateScale: function() {

            var cv = this.canvasView;
            cv.triggerMethod.apply(cv, ['updateScale'].concat( _.toArray(arguments) ));

        },

        // This is really like re-render the 'canvas view' now -- the second part (IN DOM)
        // A bit more than just the shapes -- 'edit mode' in the canvas' -- TODO: should combine these
        // could use something like onBeforeDestroy -- then hook back into render --- that way can edit view 'edit mode' and shapes at same time

        // Note: must call once the view is in the DOM -- removed 'render' from imgCanvas  Not using an 'onShow' or anything
        // else that could make this process asynchronous -- necessary for:
        // 1) setting the bounds
        // 2) rendering anything with text, which would err if not in the DOM using Raphael's library, which
        // under the hood utilizes getComputedStyle under the hood, which requires elements to be in the DOM -- comes into play
        // with the text for reason codes in regular and floating redactions
        // It's not not just shapes -- it includes setting handlers on the canvas depending on the presence of
        // Active/Find and redact notes

        // TODO: REFACTOR -- process now more intertwined with active note, aside from just the end --
        // see enter/exit edit mode, etc .. should incorporate in this as 're-render' -- and no longer just call re-render shapes
        // and also logic persisting active note shape attributes and reselected the selected shape.

        reRenderShapes: function( userProvidedShapes ) {

            // If called while in edit mode, will need to restore shapes of the active note,
            // which have yet to have been saved.
            var activeNote = this.pageCanvasCh.request('activeNote');

            var findAndRedactSearchModel =
                this.vChannel.request('findAndRedactSearchModel');


            // Note: no shape models yet applied if a hover shape has yet to be placed
            var shapesOfActiveNote = activeNote
                ? this.shapes.getShapesOfNote(activeNote)
                : null;

            var persistAttributesOfActiveNoteShapes =
                shapesOfActiveNote && shapesOfActiveNote.length > 0;

            var lastSelectedShapeUid = this.state.get('selectedShape')
                ? this.state.get('selectedShape').get('uid')
                : null;


            // Unlike find and redact shapes, these aren't persisted between re-render calls,
            // so set back the attributes necessary on the note models to re-create new shape models.
            // would be enough for modifying notes -- but if new, the note won't yet be part of the collection on the page and it's notes,
            // so we add it to the shape collection below.
            // Would be more efficient to not use the read from the DOM: save, store, the attributes in live a refactor!!!
            // Note this will kinda break the meaning of 'isNewlyDrawn' on the shapeUIModels, since they will be rendered from model
            // Note: this will give floating reason code boxes position for shapes that aren't newly drawn,
            // but that's not a huge deal.  Ultimately, when have more time this could be fixed, probably as part of larger necesary refactor
            // ( store shapes on the note, etc ).
            // I went through other references to isNewlyDrawn and others involve rendering the shapes with attributes and are ok with this change.
            // Hovershapes:
            // - will not include; their position will not be persisted between re-renders
            // - I don't think a big deal: actions that would trigger would likely have mouse outside the canvas,
            // - the worst that will happen is the hoverStamp will jump back to the default position -- looked
            // - at a fix for this, but for now not worth the effort.
            // - user can just reposition the mouse if this were to happen ( or if hidden, move mouse off and back on canvas ).
            if ( persistAttributesOfActiveNoteShapes ) {

                activeNote['isPersistingShapeModelAttributesDuringCanvasRerender'] = 1; // HACK flag for current WF

                var shapeAttributesOfNote =
                    this.shapes.getShapeAttributesOfNote( activeNote, this.scale.getScaleValue(), this.page );

                activeNote.updateAttributesToCreateShapeModelsOnCanvasReRender( shapeAttributesOfNote );

            }

            this.state.set({editMode: false});
            this.canvasView._exitEditMode(); // (Also removes hover stamp )
            this.canvasView.unsetSelectHandlerForFindAndRedact(); // TEMP: until combo with exit edit mode ( a function to call before and after based on the active/f&r note)
            this.state.set({selectedShape: null}); // 'selected shapes may not exist yet': this.pageCanvasCh.command('setSelectedShape', null);

            // F&R -- 'hack' to persist 'position of the boxes' ( which currently aren't set live )
            // F&R shapes persisted on F&R search model in between canvas render/destruction -- unlike shapes from notes
            // (new exception being FP redactions ).
            this.updateFindAndRedactFloatingShapeModels();

            this.pageCanvasCh.command('deleteAllShapes');

            // New shapes will not exist in the page note models yet, so gather these shapes back and add to collection.
            // After we set them back to a state where they are ready to be rendered
            // as if read in from the server on the note attributes (renderShapeViewFromModel)
            var newShapeModelsOfActiveNote = persistAttributesOfActiveNoteShapes && activeNote.isNew()
                ? activeNote.shapeModelsToRender( this.page )
                : null;

            this._setShapesCollection( userProvidedShapes, newShapeModelsOfActiveNote );

            this.canvasView._renderShapes( this.shapes );

            // An intermediary refactor step: much should be incorporated into render of shapes/canvas
            this.reflectActiveExpandedAndFindAndRedactNotes();

            // Reset the selected shape, if necessary --
            // Can't just use the index -- with find and redact -- the number of shapes can change when called
            // Need the uid that would be the same in between re-renders -- note_cid + shape index
            // Note: F&R shapes persisted in between -- others are not -- they are recreated from note model attributes -- above
            // With current WF must come after reflectActiveExpandedAndFindAndRedactNotes or it won't work
            var lastSelectedShape = this.shapes.findWhere({ uid: lastSelectedShapeUid });

            if ( lastSelectedShape ) {

                // Regular Note -- only re-select if still in edit mode -- save could be called after
                if ( !lastSelectedShape.isFindAndRedactShape ) {

                    if ( this.state.get('editMode') ) { // ( same as activeNote )

                        // Don't override selection from reflectActiveExpandedAndFindAndRedactNotes if 'fr.goToHit'
                        // ( Check for null so id of 0 doesn't return true )
                        if ( !findAndRedactSearchModel || findAndRedactSearchModel.get('userClickedHitId') === null ) {
                            this.pageCanvasCh.command( 'setSelectedShape', lastSelectedShape );
                        }
                    }

                } else {

                    // F & R note -- always reselect if one was selected -- not in edit mode here ( go to hit already taken care of )
                    // latter: don't override selection done above in fr.goToHit
                    if ( findAndRedactSearchModel && findAndRedactSearchModel.get('userClickedHitId') === null ) {
                        this.pageCanvasCh.command('setSelectedShape', lastSelectedShape);
                    }
                }

            }

            // Unset userClickedHitId so it's not persisted after initial render of this canvas.
            // Taken out of reflectActiveExpandedAndFindAndRedactNotes WF to not interfere with last shape selection ( above ).
            if ( findAndRedactSearchModel ) {
                findAndRedactSearchModel.set({ userClickedHitId: null }, {silent: true });
            }

            // Clear flag for hover stamps
            if ( persistAttributesOfActiveNoteShapes ) {
                activeNote['isPersistingShapeModelAttributesDuringCanvasRerender'] = 0;
            }

        },

        expandedNoteChange: function() {
            this.pageCanvasCh.command('reRenderShapes');
        },


        // Reset the shapes collection from the persisted attributes -- eg: they should now have attributes -- at least the signature todo ...
        // Essentially, put the attributes from the new shapes persisted on the notes onto the shape ui objects ...
        noteSaved: function() {
            this.pageCanvasCh.command('reRenderShapes');
        
        },
        noteDeleted: function(note) {
            _.each(this.shapes.getShapesOfNote(note), function(shape) {
                this.pageCanvasCh.command('deleteShape', shape);
            }, this);
        },

        activeNoteSubTypeChange: function(subType, options) {

            var isEntering = options.activeNote;

            (isEntering && options.changeOrigin !== 'shapeSelected') &&
                this._unselectAllShapes();

            // TODO: any other options other than active note here --  also could simplify and get in fn where needed
            // from the state ?
            isEntering && this.canvasView._enableDrawing( subType, options.activeNote );

        },
        /**
         * Going forward, probably best to get the derived color using the central fn ( and not pass the parameter )
         * But we still need to set the 'zone' color on the shape models, which is done here.
         * color: hex
         */
        setDrawColor: function( color ) {

            var shape = this.pageCanvasCh.request('selectedShape');
            shape && this.canvasView.shapeViewFromModel(shape).triggerMethod( 'changeColor', color );

            this.pageCanvasCh.trigger( 'textAreaView.updateColor' , color );

        },
        setStrokeWidth: function( strokeWidth ) {

            var shape = this.pageCanvasCh.request('selectedShape');
            shape && this.canvasView.shapeViewFromModel(shape).triggerMethod( 'changeStrokeWidth', strokeWidth );

        },

        // Now only listened to by hover edit dialog
        // ( page container overflow scroll, sidePanel drag, side panel toggle, toggle full screen )
        // ( note -- for the latter 2: will be called twice with set scale )
        repositionShapeDialog: function() {
            this.canvasView.shapeViews.call('trigger', 'shape.repositionShapeDialog');
        },


        /**
         * When a modal window is shown -- close dialogs -- click event may not propagate to body.
         * For new notes, this was always getting called -- presumably b/c of edited
         * one's which weren't getting selected ( something else to look into ).
         * Now also called if FR dialog is opened.
         */
        closeCanvasDialogs: function() {
            this.pageCanvasCh.trigger('canvas:closeAllDialogs');

        },
        graphicStampChanged: function() {
            this.canvasView.graphicStampChanged.apply(this.canvasView, arguments);
        },
        consultGroupChange: function( note ) {

            var ch = this.pageCanvasCh;

            _.invoke( this.shapes.getShapeUIModelsOfNote(note), 'trigger', 'shape:consultGroupChange' );

            // Could get active subType ...
            note.isSVGGraphicNote() &&
                ch.trigger( 'textAreaView.updateColor', ch.request('getColorToApplyToShape', note) );

            // One-off for the hover signature, which currently isn't a view
            note.isSignature() && this.canvasView.hoverShape &&
                ch.trigger( 'hoverSignature:consultGroupChange', ch.request('getColorToApplyToShape', note) );

        },

        // Re-draw all shapes to take into account the difference in appearance of redaction shapes.
        // ( Could just do redaction shapes but performance is good here ).
        // Note: because things don't have opacity, order may change (like when editing/creating new notes).
        // If any issues encountered, could just get all redaction shape (and subview) attributes to change their settings.
        // Perhaps an attribute on the redactionShape uiModel would be beneficial.
        applyAllRedactionsToggled: function() {
            this.pageCanvasCh.command('reRenderShapes');
        },

        pageRotated: function() {
            this.pageCanvasCh.command('reRenderShapes');
        }


    },
    localCommands: {

        /* when add newly drawn shape, need to create the shape model from which is it drawn */
        addNewlyDrawnShape: function(shapeEl) {

            var activeNote = this.pageCanvasCh.request('activeNote');

            var nShapesOfNote = this.shapes.getShapesOfNote( activeNote ).length;

            // If do this, sloppier, but don't need to worry about tracking the number of shapes on the note model on parse/add/delete/etc
            // Eg: here it avoids - something like:
            // And for now allows us to avoid getting into parsing shape models on the note models
            // For now -- the uid is necessary for re-selection of the shape on re-renderShapes

            /*
                activeNote['numberShapes'] =
                    ( activeNote['numberShapes'] ? activeNote['numberShapes'] : 0 ) + 1;

            */

            var options = {
                    parentNote: activeNote,
                    channel: this.pageCanvasCh,
                    raphaelEl: shapeEl,
                    isActive: true,  // must be active
                    isExpanded: false,
                    pageModel: this.page, /* don't rely on getting off note -- ensure it's the full page model (or the correct one when necessary) */
                    isNewlyDrawn: true,
                    shapeIndexOfNote: nShapesOfNote++
                };


            var ShapeModelConstructor = activeNote.getShapeModel();
            var shapeModel = new ShapeModelConstructor([], options);

            this.shapes.add(shapeModel); /* no event */
            this.canvasView.renderShapeViewFromModel(shapeModel, this.scale.get('scale'), false); // (must have permission)
            this.pageCanvasCh.command('setSelectedShape', shapeModel);

        },

        cancelSignature: function(note) {
            this.pageCanvasCh.trigger('cancelSignature', note);
        },

        /**
         * Delete model from this.shapes and destroy its corresponding view from the canvas shapeViews collection.
         * Single entry point for shape deletion.
         * manualUserDelete: true if called from delete button or delete/backspace hotkey,
         * comes into play with floating redactions
         * TODO: if it's the selected shape, set the selected shape to null (?) -- see also replaceExistingTextStampShapeWithHoverStamp
         */
        deleteShape: function(shape, manualUserDelete) {

            this.canvasView.destroyShapeView(shape, manualUserDelete);
            this.shapes.remove(shape);


            // For shapes that are persisted on note models -- see comment in class model
            shape.uiModel.resetActiveAndExpandedState();

        },

        // Clone: -- otherwise not all will be deleted -- (eg the # of shapes will not be the same as it was when started
        // Update 10.1.20: clone still required, otherwise, we get 'duplicates' printed -- may want to look into WF here.
        deleteAllShapes: function() {

            var shapes = this.shapes.clone();

            shapes.each(function(s) {
                this.pageCanvasCh.command('deleteShape', s);
            }, this);

        },

        setSelectedShape: function(shape) {

            this.state.set('selectedShape', shape);
            shape
                ? this._selectShapeAndUnselectOthers(shape)
                : this._unselectAllShapes();


        },
        toggleUserDrawing: function(isDrawing) {

            var activeNote = this.pageCanvasCh.request('activeNote');
            
            // Set a flag on the note model that will not allow the user to save it while the shape is being drawn
            activeNote.uiModel.set('isUserDrawingShape', isDrawing);

            // This was the old callback after set
            this.state.set('isDrawing', isDrawing);
            this.pageCanvasCh.trigger('drawingToggled',isDrawing, activeNote);

            if ( !activeNote.isRedactionNote() )
                return;

            _.each( this.shapes.getShapeUIModelsOfNote(activeNote), function(s) {
                s.set('isParentNoteDrawing', isDrawing);
            });

        },

        replaceExistingTextStampShapeWithHoverStamp: function() {

            var activeNote = this.pageCanvasCh.request('activeNote');
            var currentShapeModel = this.pageCanvasCh.request('selectedShape'); // ( it must be selected )

            this.state.set({selectedShape: null}); // Temp: should put into delete shape routine ( which doesn't unset the selected shape )

            this.pageCanvasCh.command( 'deleteShape', currentShapeModel );
            this.canvasView._enableDrawing( 'text_stamp', activeNote );

        },

        destroyTextArea: function() {
            // would have the shapes listen to an event; but also remove the view from canvasView
            // (its like a flag)
            this.canvasView.destroyTextAreaView();
        }

    },
    localRequests: {
        selectedShape: function() {
            return this.state.get('selectedShape');
        },
        editMode: function() {
            return this.state.get('editMode');
        },
        state: function() {
            return this.state;
        },
        getPage: function() {
            return this.page;
        },
        vChannel: function() { //for internal fer to vChannel for requests
            return this.vChannel;
        },
        viewerContainer: function() {
            return this.vChannel.request('getWrapper');
        },
        activeNote: function() {
            return this.vChannel.request('activeNote');
        },
        expandedNote: function() {
            return this.vChannel.request('expandedNote');
        },
        activeNoteSubType: function() {
          return this.vChannel.request('activeNoteSubType');
        },
        scale: function() {
            return this.scale;
        },
        currentScaleValue: function() {
          return this.scale.getScaleValue();
        },
        shapes: function() {
            return this.shapes;
        },

        getCurrentDrawingAttributes: function() {
            return this.vChannel.request('getCurrentDrawingAttributes');
        },

        canvasContainerRel: function() {
            return this.canvasView.containerRel;
        },


        /*
        * ** Centralized Setting of Attributes & Colors -- An intermediate refactor **
        * Get the raphael attributes to apply to an element -- incorporates logic to apply appropriate color.
        * Color is used to set various Raphael properties like fill, stroke.
        * Works for shapes that don't yet have a model/view yet and those that do.
        * note: required
        * active: required: want edit (true) or non edit attributes (false)
        * shape: can be empty ( in the current workflow that's if during initial draw
        * noteSubType: can be empty ... now only applicable to graphic notes
        * Sources:
        * - baseCanvasDrawnFns.setShapeAttrs ( shape will not be defined )
        * - coordinateShape.getNonPathActiveSVGAttrs
        * - coordinateShape.getNonPathInactiveSVGAttrs
        * */
        getAttributesToApplyToShapeEl: function( note, active, shape, noteSubType ) {

            var attrs = {},
                ch = this.pageCanvasCh,
                colorToApply = ch.request( 'getColorToApplyToShape', note, shape );

            if ( !shape ) {

                if ( note.isSVGGraphicNote()  ) {

                    // if employ more color pickers for other types, may want to utilize note.supportsColorPicker ...
                    attrs = note.defaultSVGAttrsEdit( colorToApply, noteSubType, ch.request( 'getCurrentDrawingAttributes' ) );

                } else {

                    attrs = note.defaultSVGAttrsEdit( colorToApply, noteSubType );

                }

            } else {

                if ( !active ) {

                    attrs = note.defaultSVGAttrs( colorToApply );

                } else {

                    attrs = note.defaultSVGAttrsEdit( colorToApply );

                }

            }

            return attrs;

        },

        /**
         * Centralized logic to derive shape colors -- * only go through here *
         * The cascade of rules to apply
         * Intermediary refactor: combines logic from the note level and the shape level when it exists --
         * a shape may not always exist so this is why it's not put on the shape model.
         * Note: required -- the note model
         * Shape: shape model: won't exist for newlyDrawn shapes -- and that is where we store the zone color
         * Text Stamps:
         * - the logic is a bit different ( no current currentDrawing attributes )
         * - similar logic is duplicated on the note model here b/c we need it in the note view:
         *   ... theTextColor is stored on the note model as well as shape models
         * - look at this when refactor to implement zone color for non graphic notes
         * - potential reason to refactor to where shapes are parsed and set with the notes, not just derived,
         *   when we need them for the canvas ( eg full page redactions )
         */
        getColorToApplyToShape: function( note, shape ) {


            if ( note.isTextStamp() ) {
               return note.uiModel.getColorToApply();
            }

            // First look at any 'overriders' of the 'actual color' -- consults and group color

            // 1) Consult Group -- if the system supports them,
            //    and only one with a color assigned is applied to the note ( note level )

            if ( fvChannel.request('supportConsults') ) // could cache for perf.

                var consultGroupColor = note.getCurrentConsultColorForShapes(); // logic appears to handle setting this live ( vs deriving from selected consult groups )
                if ( consultGroupColor )
                    return consultGroupColor;


            // 2) Groups of Note Creation User ( if belongs to one group with 1 color assigned )
            // ( must override zone color -- otherwise  group color would never get applied ( see discussion in ticket DVBC-1780 )
            var noteCreationUserGroupColor = note.getCreationUserGroupColor();
            if ( noteCreationUserGroupColor ) {
                return noteCreationUserGroupColor;
            }

            // 3) Zone Color -- all shapes should have ( from DB or color picker )
            // ( color pickers disable if any of the above 2 overrides exist.

            if ( shape ) {

                var zoneColor = shape.getZoneColor();
                if ( zoneColor ) {
                    return zoneColor;
                }

            }

            else {

                // Note: color pickers would be disabled if there is an 'override'
                // Now only SVGGraphicNotes
                if ( note.supportsColorPicker() ) {

                    return this.pageCanvasCh.request( 'getCurrentDrawingAttributes').color;

                } else {

                    return note.getDefaultShapeColor();

                }

            }

        }

    },

    // From re-render shapes - at the end
    reflectActiveExpandedAndFindAndRedactNotes: function() {

        var activeNote = this.pageCanvasCh.request('activeNote'); // utilize for now

        // Shouldn't reach if not drawable but leave an extra check
        var isDrawableActiveNote = activeNote && activeNote.isDrawable();

        if ( isDrawableActiveNote ) {
            this.state.set({editMode: true}); //(just storage)
            this.activeNoteChange(activeNote);
        }

        var expandedNote = this.pageCanvasCh.request('expandedNote');
        if ( expandedNote ) {
            this.expandedNoteChange(expandedNote);
        }

        // TODO: we should want this just off shape render ... that should be next ... just get going now to text active ?
        var findAndRedactSearchModel =
            this.vChannel.request('findAndRedactSearchModel');


        if ( findAndRedactSearchModel && findAndRedactSearchModel.searchHasResults() ) {

            var pageId = this.page.get('pageId');

            var hitShapesOfPage = findAndRedactSearchModel.get('searchResults').getAllShapesPerPage( pageId );

            if ( hitShapesOfPage && hitShapesOfPage.length > 0 ) {

                var hitShapeOfPageUiModels =  hitShapesOfPage.map( function(shape) {
                    return shape.uiModel;
                });

                // TODO: this is temp -- will need some sort of 'reset' of the UI models ... need to map this out ...
                // these would not have been destroyed ...
                // They may also be holding on to the raphael el's which we don't want .
                 hitShapeOfPageUiModels.forEach( function( shapeUiModel ) {
                     shapeUiModel.deactivate();
                     // also unselect ... that's done below ... could combo
                 });

                // TODO: also need to handle mouseover
                // -- that trigger the pageNoteModel; here we want the shape --> so extend the shapeView...

                _.invoke( hitShapeOfPageUiModels, 'activate' );

                // For Floating, need to enable layer and drag them ... ( again, this should be done on render )
                // Note: there is no activeNote on them now.
               //  New: there can be > 1.
                // TODO: handle in the render process when refactor!


                findAndRedactSearchModel.get('searchResults').getTopDownResults().getFloatingReasonCodesNotesOfPage( pageId ).forEach( function( note ) {
                    note.floatingCodesController &&
                        note.floatingCodesController.trigger('floatingCodesView.toggleActive', 1, this.canvasView.paper );
                }, this);


                /* -------'goToHit'/selection --------- */

                // Here -- handle entry of the 'goToHit' and shape selection.
                // All shapes already unselected in re-render.
                // Alternatively, we select the shape first (now that we use selected) and just incorporate into render of the shapes
                // with active and expanded
                // TODO: incorporate into re-render process -- part of unselect all shapes ( though these attributes are persisted )
                _.invoke( hitShapeOfPageUiModels, 'unSelect');

                var userClickHitId = findAndRedactSearchModel.get('userClickedHitId');
                if ( userClickHitId !== null ) { // ( can be zero )

                    var shapeOfClickedHit = _.find(hitShapesOfPage, function(s) {
                        return s.get('hitId') === userClickHitId;
                    });

                    // Utilize the existing isSelected attribute (independently of notes)
                    // shapeOfClickedHit.uiModel.select(); // need make the 'selected note' for last note selection process above ( not just set the attribute ) -
                    // ( selectedShape must be set )
                    this.pageCanvasCh.command( 'setSelectedShape' , shapeOfClickedHit );

                }

                // userClickedHitId unset at end of re-render process so as not to interfere with lastShape selection -- see re-render ...

                /**
                 * Allow for unselection of the selected shape.
                 * Don't do if activeNote -- this will be handled by drawStart ( only if there is not active mode )
                 */
                if ( !isDrawableActiveNote ) {

                    // Will need to turn off

                    this.canvasView.setUnselectedShapeHandlerForFindAndRedact();

                }


            }

        }




    },

    // TODO: This some of this ( at least the shapes ) should now be combined with render ...
    // Since re-rendering -- this only encompasses enter now -- it's not a change
    // Intermedite refactor step
    activeNoteChange: function(note) {

        // Also sets mousedown listener that will handle shape selection
        // Always set the listener even if find and redact shapes
        this.canvasView.enterEditMode( note );

        // TODO: set on model and then do on render of the shapes
        _.invoke( this.shapes.getShapeUIModelsOfNote(note), 'activate' );

        /**
         * If a floating code redaction note, toggle active on it's floating codes controller
         *( for layering, do after all shapes have been toggle active, which puts them to the front )
         * ( don't call on all: eg don't want to enable drag on code boxes of notes other than the active note )
         * This does allow you to drag the code boxes of the active note
         * TODO: if refactor: i think we now just do on render
         */
        note.floatingCodesController &&
            note.floatingCodesController.trigger('floatingCodesView.toggleActive', 1, this.canvasView.paper );

        // If the active note is graphic, make any others appear 'disabled'
        note.isSVGGraphicNote() &&
            _.invoke(this.shapes.getAllShapesButNote( note, note.getNoteType() ), 'setDisabled');

    },

    // Now just the entering part from the original event (shapes re-rendered)
    expandedNoteChange: function( note ) {

        var shapeUiModesOfNote = this.shapes.getShapeUIModelsOfNote(note);
        _.invoke( shapeUiModesOfNote, 'setExpanded' );

    },


    toggleShapeMouseOver: function( note, options ) {

        this.toggleHighlightedNote.apply(this, arguments);
        this.pageCanvasCh.trigger('hoveredNoteChange', note, options.isEntering ? 1 : 0); //note: this also an external req

    },
    toggleHighlightedNote: function(note, options) {

        var ch = this.pageCanvasCh,
            shapes = this.shapes;

        if ( ch.request('editMode') || ch.request('vChannel').request('noteIsActiveOrExpanded') )
            return false;

        options.isEntering
            ? _.invoke(shapes.getShapeUIModelsOfNote(note), 'highlight') // could cache per note
            : _.invoke(shapes.getAllShapeUIModels(), 'unhighlight');

    },
    _selectShapeAndUnselectOthers: function(shape) {

        this.shapes.each( function(s) {
            s.uiModel.set( 'isSelected', s.cid === shape.cid );
        });

    },
    _unselectAllShapes: function() {

        _.invoke( this.shapes.getAllShapeUIModels(), 'unSelect');

    },

    /**
     * First -- must call before canvas is destroyed:
     * - Issue: reason code box data is stored on the floating codes controller of the note,
     *  which will be destroyed on destruction of the canvas.
     * - Persist the floating codes controller before it's destroyed (eg on page change)
     *      - Note: this will just check the mode; want to ensure we're only working with the notes on this canvas, not another
     *      - Don't check mode from vChannel ( maybe the shapes were deleted ), just check for their existence on the canvas.
     * Second -- discovered needed anything that would be needed on 're-render of the canvas' to persist
     *  - codes box locations using the existing model ( not saving on move )
     *  with the code boxes, though needs to go through how that's working with the lines, etc.
     *  TODO:
     *      - now that we are updating the location the shapes on move / resize, maybe we make that consistent with the boxes
     *      - this is difficult now, need to outline and refactor; get functionality working
     */

    updateFindAndRedactFloatingShapeModels: function() {

        if (!this.shapes)
            return;

        /* There can now be more than one note on a page for find and redact */
        var findAndRedactShapesOfFloatingReasonCodeNotes = this.shapes.filter( function(s) {
            return s.isFindAndRedactShape && s.parentNote.isFloatingRedaction() && s.parentNote.floatingCodesController ;
        });

        if ( findAndRedactShapesOfFloatingReasonCodeNotes.length > 0 ) {

            // *** Update the shape's attributes ***
            // What they are rendered from on the canvas ... not the 'shapes' attribute of the note ***
            // Now updating the shape models, as opposed to deleting and recreating them (as they are persisted for F & R)
            var scale = this.scale.getScaleValue();

            findAndRedactShapesOfFloatingReasonCodeNotes.forEach( function(shape) {
                shape.updateShapeAttributes( scale );
            });

        }

    },

    onBeforeDestroy: function() {

        // Check for shapes -- eg if call a destroy prior to a render ('reset'), these won't exist
        if ( this.shapes ) {

            // Update the shape attributes from the shape models on the find and redact search model prior to destruction
            // of the floating codes controller
            this.updateFindAndRedactFloatingShapeModels();

            // TODO: better destroy workflow -- eg if put below with other this.shapes, won't get destroyed
            // this is a VERY QUICK FIX
            // ensure all shapes are not selected -- eg if change page with find and redact hit -- it's view will not be selected
            this.pageCanvasCh.command('setSelectedShape', null);

        }

        _.invoke([ this.canvasView, this.state ], 'destroy'); //this.page, this.scale


        // Check for shapes -- eg if call a destroy prior to a render ('reset'), these won't exist
        // do before canvasView destroy -- otherwise shapes will be gone already; needs better org
        if ( this.shapes) {


            // TODO: this should also reset the UI models ... see above ...
            this.shapes.triggerMethod('destroy'); //-- causing mem leak ...

            this.shapes = null;

        }

        this.pageCanvasCh.reset();

        Marionette.unbindEntityEvents(this, this.pageCanvasCh, this.localEvents);
        Marionette.unbindEntityEvents(this, this.pageCanvasCh, this.outerEvents);

    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/canvas.js
 ** module id = 356
 ** module chunks = 0
 **/